var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHouseholdData = function SvgHouseholdData(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.5 22.615V20.5H5.308q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V5.308q0-.758.525-1.283T5.308 3.5H10.5V1.385H12v21.23zM5.308 19H10.5v-2.5H7.25V15h3.25v-2.25H7.25v-1.5h3.25V9H7.25V7.5h3.25V5H5.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v13.384q0 .116.096.212a.3.3 0 0 0 .212.096m8.788-14V3.5h4.692q.758 0 1.283.525t.525 1.283v13.384q0 .758-.525 1.283t-1.283.525h-4.692V19h4.692a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212V5.308A.3.3 0 0 0 19 5.096.3.3 0 0 0 18.788 5zm0 7.75v-1.5h3.25v1.5zm0-3.75V7.5h3.25V9z"
  })));
};
export default SvgHouseholdData;